<template>
	<div class="width-100">

		<div class="subheader display-flex justify-content-space-between align-items-center width-100 height-fixed-64 font-size-4">
			<nav>
				<ol class="breadcrumbs display-flex">
					<li v-if="templateData.post.title_text">{{ dtPost.title_text }}</li>
					<li v-else>Overview</li>
					<li>{{ templateData.label }}</li>
				</ol>
			</nav>

			<div 
				:class="`Badge Badge_status Badge--${ templateData.status_color }`">
				<span class="caption-uppercase">{{ templateData.status }}</span>
			</div>
		</div>
		<main class="details-area display-flex">
			<div 
				v-if="! dtPost.hide_sidebar"
				class="detail-side">
				<div>
					<a class="collapse-detail-side" href=""><span class="icon icon-Chevron-Left-Small"></span></a>
					
					<div class="DataTableWrapper DataTable--small DataTable--hoverable">

						<table class="DataTable"
							v-if="templateRows"
							>
							<tbody>
								<template
									v-for="templateRow in templateRows"
									:key="templateRow.index"
								>
								<!-- {% if not template_row.conditional_columns or row_has_columns( database_data, template_row.conditional_columns ) %} -->
									<tr class="DataTable__row">
										<td class="DataTable__cell font-weight-bold">{{ templateRow.label }}</td>
										<td class="DataTable__cell">{{ templateRow.render }}</td>
									</tr>
								<!-- {% endif %} -->
								</template>
							</tbody>
						</table>
					</div>
				</div>
				<div class="action-buttons"> 
					<template v-if="conditionalActionButtons">
						<a v-for="btn in conditionalActionButtons" :key="item.index"
							class="Btn Btn--small Btn--outline" 
							:href="btn.url">{{ btn.button_text }}</a>
					</template>
				</div>
			</div>

			<div class="details-main" 
				id="details-main" 
				:style="dtPost.hide_sidebar ? 'border-left: none' : null"
				>
				
				<template v-if="topProcessMap">
					<div class="timeline {{ process_map.post.progress_bar ?: 'no-progress-bar' }}">
						{% include 'components/process-map/_process-map-component.twig' with { component: process_map } %}
					</div>
				</template>
				<template v-else-if="topStepper">
					<TopStepperComponent 
						:stepper="topStepper"
						/>
				</template>
  
	        	
	            <div class="tabs-section">
	            	<template v-if="tabs">

						<!-- <ul class="Tabs Tabs--border" role="tablist">
							<li 
								v-for="tab in tabs"
								:key="tab.index"
								role="presentation"
								>
								<button 
									role="tab"
									aria-selected="true"
									:aria-controls="`tab-${tab.index}`" 
									class="Tabs__item caption-uppercase"
									:class="tab.index == 1 ? 'Tabs__item--active' : null"  
									>{{ tab.tab_title }}</button>
							</li>
						</ul> -->

					
						<div class="tab-content">

							<n-config-provider inline-theme-disabled :theme-overrides="themeOverrides">
							    <n-tabs 
							    	:default-value="currentTabId" 
							    	type="line" 
							    	pane-class="tab-pane-wrapper"
							    	@update:value="tabsUpdate"
							    	>
									<template v-for="tab in tabs"
										:key="tab.index">

										<n-tab-pane 
											:name="`tab-${tab.index}`" 
											:tab="tab.tab_title"
											:display-directive="`show:lazy`"
											>
								        	<DetailsViewTab 
												:class="`tab-pane tab-content-${ tab.acf_fc_layout} ${ tab.index == 1 ? 'active' : '' }`" 
												:id="`tab-${tab.index }`" 
												role="tabpanel" 
												:aria-labelledby="`tab-${ tab.index }`" 
												:data-links-target="tab.links_target ?? 'window'"
												>
												
												<!-- {% include 'components/dataviews/_dataview-component.twig' with { datatable: tab.component_template_data } %} -->
												<div 
													v-if="'data_view' == tab.acf_fc_layout"
													class="dt-wrap mb-4"
													:class="`${ tab.component_template_data.database_columns_data ? '' : 'no-results' }`" 
													:dt-id="tab.component_template_data.data_view.id">
													<DataviewComponent 
														v-if="tab.component_template_data.data_view" 
														:templateData="tab.component_template_data" 
														@refresh="refreshDataview"
														/>
												</div>

												<template v-else-if="'folder_view' == tab.acf_fc_layout">
													<!-- {# <pre>{{tab.component_template_data | print_r }}</pre> #} -->
													<!-- {% include 'components/folder-views/_folder-view-component.twig' with { component: tab.component_template_data } %} -->
													folder view
												</template>
												<template v-else-if="'iframe' == tab.acf_fc_layout">
												<!-- {% if tab.acf_fc_layout == 'iframe' %} -->
													<iframe  
														:src="tab.source" frameborder="0"></iframe>
												<!-- {% endif %} -->
												</template>
												<template v-else-if="'module' == tab.acf_fc_layout">
													<ModuleComponent
														v-if="tab.component_template_data"
        												:templateData="tab.component_template_data" 
														/>
													<!-- {% include 'components/modules/_module-component.twig' with { module: tab.component_template_data } %} -->
												</template>
												<template v-else-if="'stepper' == tab.acf_fc_layout">

													<div class="stepper-tab-wrapper">
														<StepperComponent 
															:templateData="tab.component_template_data"
															/>
														<!-- {% include 'components/steppers/_stepper-component.twig' with { stepper: tab.component_template_data, hide_default_modal: true } %} -->
													</div>
												</template>
												<template v-else-if="'process_map' == tab.acf_fc_layout">
													<div class="process-tab-wrapper">
														<ProcessMapComponent
															:templateData="tab.component_template_data"
															/>
														<!-- {% include 'components/process-maps/_process-map-component.twig' with { component: tab.component_template_data, hide_default_modal: true } %} -->
													</div>
												</template>

												<template v-else-if="'dashboard' == tab.acf_fc_layout">

													<div class="dashboard-tab-wrapper">
														<!-- {% include 'components/dashboards/_dashboard-component-vue.twig' with { post: tab.component_template_data.post } %} -->
														<!-- dashboard -->
														<DashboardComponent
																:chartsGroups="tab.component_template_data.charts_groups ?? []"
															/>
													</div>
												</template>

											</DetailsViewTab><!--/.tab-pane-->
								      	</n-tab-pane>

									</template>
								</n-tabs>
							</n-config-provider>
							<div 
								id="iframe-tab-wrapper"
								:class="iframeTabWrapperClass"
								>
						        <button class="Btn-icon Btn-icon--big Btn-close"
					        		@click="closeTabIframe"
						        	>
						            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.9394L16.9697 5.96961L18.0304 7.03027L13.0606 12L18.0303 16.9697L16.9697 18.0304L12 13.0607L7.03045 18.0302L5.96979 16.9696L10.9393 12L5.96973 7.03042L7.03039 5.96976L12 10.9394Z" fill="#1F2328"/>
						            </svg>
						        </button>
						        <iframe 
						        	:src="iframeSrc" 
						        	frameborder="0"></iframe>
						    </div>
						</div>
					</template>
				</div>
				
			</div>
		</main>
	</div>

</template>


<script>
import TopStepperComponent from '@vueapp/components/steppers/TopStepperComponent.vue'
import DataviewComponent from '@vueapp/components/DataviewComponent.vue'
import DashboardComponent from '@vueapp/components/DashboardComponent.vue'
import ProcessMapComponent from '@vueapp/components/ProcessMapComponent.vue'
import ModuleComponent from '@vueapp/components/ModuleComponent.vue'
import StepperComponent from '@vueapp/components/StepperComponent.vue'


import DetailsViewTab from '@vueapp/components/details-views/DetailsViewTab.vue'

export default {
	name: 'DetailsViewComponent',
	props: {
		templateData: {
			required: true,
			type: Object,
			default: {}	
		},
		currentTabId: {
			required: true,
			type: String,
			default: 'tab-0'
		}
	},
	components: {
		DetailsViewTab,
		TopStepperComponent,
		DataviewComponent,
		DashboardComponent,
		ProcessMapComponent,
		ModuleComponent,
		StepperComponent
	},
	emits: ['currentTabChange'],
	data() {
		return {
			iframeTabWrapperOpen: false,
			iframeSrc: null,
			iframeRedirect: null,
			themeOverrides: {
			    common: {
			      	primaryColor: '#186BF2',
			      	textColor1: '#6C7789',
			      	tabGap: '32px',
			      	dividerColor: '#CCD0D7',
			    },
			    Button: {
			      	textColor: '#000000'
			    },
			    Tab: {
			    	gapPad: '32px',
			    	color: 'red'
			    }
			}
		}
	},
	methods: {

		tabsUpdate(value) {
			// alert(value)
			this.$emit('currentTabChange', value)
		},

		refreshDataview() {
			console.log('DetailsView::refreshDataview()::')
		},


		dvTopButtonActionHandler(e, data) {

			// console.log(e)

			const button = data.button,
				linksTarget = data.linksTarget,
				tabId = data.tabId ?? this.currentTabId,
				href = data.href,
				redirect = data.redirect


            let el = e.currentTarget
                // href = $el.attr('href')
                // $tab = $el.closest('.tab-pane.active'),
                // link_target = $tab.attr('data-links-target')

            const tab = document.getElementById(tabId)

            // alert(href)

            // $('body').removeClass('iframe-is-open');
            // $('#iframe-tab-wrapper').removeClass('active')
            document.body.classList.remove('iframe-is-open');
            document.getElementById('iframe-tab-wrapper').classList.remove('active')
            

            let $iframe_wrapper =  $('.tab-content #iframe-tab-wrapper') //link_target == 'tab' ? $('.tab-pane.active #iframe-tab-wrapper') : $('.tab-pane.active #iframe-tab-wrapper')

            if ( 'window' == linksTarget ) {
            	document.location.href = href
            	return
            }

            if ( el.getAttribute('target') != '_blank' ) {

                e.preventDefault() 

                let $iframe = $('iframe', $iframe_wrapper)
                let src = new URL(href);

                src.searchParams.append('embedded-layout', '1');

                if ( 'overlay' === linksTarget ) {
                    // $('body').addClass('overlay-is-active');
                    document.body.classList.add('overlay-is-active')
                }

                if ( 'right' === linksTarget ) {
                    // $('body').addClass('top-tab-is-active');
                    document.body.classList.add('top-tab-is-active')
                }

                if ( 'split' === linksTarget ) {
                    document.body.classList.add('split-tab-is-active')
                    if ( ! $('.Btn.top-action-button', $tab).length ) {
                        document.body.classList.add('no-top-button')
                    }
                }

                $('#context-menu').css('visibility', 'hidden')
                
                // $iframe.attr( 'src', src )
                $iframe_wrapper.append($iframe)

                this.iframeSrc = src
                this.iframeRedirect = redirect
                

                // $iframe_wrapper.addClass('active')
                // $('body').addClass('iframe-is-open');

                this.iframeTabWrapperOpen = true
                document.body.classList.add('iframe-is-open')

                if ( el.getAttribute('data-redirect') == 'close-module' ) {
                    $('iframe', $iframe_wrapper).attr('data-session-finished', 'close')
                } else {
                    $('iframe', $iframe_wrapper).attr('data-session-finished', el.getAttribute('data-redirect'))
                }


                return false;
            }
		},

		closeTabIframe(e) {
			e.preventDefault()
            let iframe_wrapper = document.querySelector('.tab-content #iframe-tab-wrapper')

            if ( iframe_wrapper ) {
                // let $iframe = $('iframe', $iframe_wrapper)
                // $iframe.attr('src', '')
                // $iframe_wrapper.removeClass('active')

            	this.iframeSrc = null
                this.iframeTabWrapperOpen = false

                document.body.classList.remove(
                		'iframe-is-open', 
                		'overlay-is-active', 
                		'top-tab-is-active', 
                		'split-tab-is-active', 
                		'no-top-button'
                		)
            }
        
		},

		bryterModuleEventListener(event) {
			if (event.data.type === 'bryter:module' && event.data.action === 'sessionFinished') {
                if ( this.iframeRedirect == 'close-module' ) {
                	this.iframeSrc = null
	                this.iframeTabWrapperOpen = false

	                document.body.classList.remove(
	                		'iframe-is-open', 
	                		'overlay-is-active', 
	                		'top-tab-is-active', 
	                		'split-tab-is-active', 
	                		'no-top-button'
	                		)

                	this.$emit('refresh', {})

                }
                
            }
		}
	},

	computed: {
		dtPost() {
			return this.templateData.post
		},
		conditionalActionButtons() {
			return this.templateData.conditional_action_buttons
		},
		templateRows() {
			return this.templateData.template_rows
		},
		tabs() {
			// console.log('tabs::', this.templateData.tabs)
			return this.templateData.tabs
		},
		topProcessMap() {
			return this.templateData.top_process_map
		},
		topStepper() {
			return this.templateData.post.top_stepper_enabled ? this.templateData.top_stepper : false
		},

		iframeTabWrapperClass() {
			return this.iframeTabWrapperOpen ? 'active' : null
		},

	},

	created() {
		const t = this
		this.emitter.on('topActionButtonClick', function(e) {
			const button = e.button,
				event = e.event,
				tabId = e.tabId,
				linksTarget = e.linksTarget,
				href = e.href,
				redirect = e.redirect
			t.dvTopButtonActionHandler(event, {
					button, tabId, linksTarget, href, redirect
				})
		})

		this.emitter.on('topStepperButtonClick', e => {
			const button = e.button,
				event = e.event,
				linksTarget = e.linksTarget,
				href = e.href,
				redirect = e.redirect
			t.dvTopButtonActionHandler(event, {
					button, linksTarget, href, redirect
				})
		})


		this.emitter.on('processMapButtonClick', e => {
			const button = e.button,
				event = e.event,
				linksTarget = e.linksTarget,
				href = e.href,
				redirect = e.redirect
			t.dvTopButtonActionHandler(event, {
					button, linksTarget, href, redirect
				})
		})

		window.addEventListener('message', this.bryterModuleEventListener)
	

	}
}
</script>


<style>
	body {
		--n-tab-text-color: red;
		--n-tab-text-color-active: #186BF2;
	}
</style>